module.exports = require("./de-AT.js");